<div class="select-all-wrapper" (click)="toggle($event)">
  <mat-checkbox
    class="select-all-checkbox"
    [checked]="areAllSelected"
    [indeterminate]="isIndeterminate"
    (click)="$event.preventDefault()">
  </mat-checkbox>
  <span class="select-all-label">{{ 'common.buttons.selectAll' | transloco }}</span>
</div>
<mat-divider></mat-divider>
